const platform = navigator.userAgent || navigator?.platform || 'unknown';

export const isMacintosh = () => platform.indexOf('Mac') > -1;

export const isWindows = () => platform.indexOf('Win') > -1;

export const getModifierKeyPrefix = () => (isMacintosh() ? '⌘' : 'Ctrl');
